import React from 'react'
import ALLLeaveRequestList from '../components/AllLeaveRequestList'
import HRMSLayout from '../../../../../layout/components/HRMSLayout'

function LeaveRequestDashboardPage() {
  return (
    <HRMSLayout>
        <div className='row'>
          <div className='col-md-12'>
            <ALLLeaveRequestList />
          </div>
        </div>
    </HRMSLayout>
  )
}

export default LeaveRequestDashboardPage